import React, { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from '@mui/material';
import {
  DashboardTwoTone,
  LockOpenTwoTone,
  SettingsTwoTone,
  Menu as MenuIcon,
  ArticleTwoTone,
} from '@mui/icons-material';
import { map } from 'lodash/fp';
import { apiurl } from './constants';

const ITEM_HEIGHT = 48;

const HeaderMenu = ({ logOut }) => {
  const history = useHistory();
  const anchorEl = useRef(null);
  const [open, setOpen] = useState(false);

  const handleClick = (event) => {
    setOpen(true);
    anchorEl.current = event.currentTarget;
  };
  const handleClose = () => {
    setOpen(false);
    anchorEl.current = null;
  };

  const getMenuOptions = () => {
    const clickHandler = (fn) => () => {
      fn();
      handleClose();
    };
    return [
      {
        label: 'Requests',
        Icon: DashboardTwoTone,
        selected: window.location.pathname === '/requests',
        onClick: clickHandler(() => {
          history.push('/requests');
        }),
      },
      {
        label: 'Events',
        Icon: DashboardTwoTone,
        selected: window.location.pathname === '/events',
        onClick: clickHandler(() => {
          history.push('/events');
        }),
      },
      {
        label: 'Resources',
        Icon: ArticleTwoTone,
        onClick: clickHandler(() => {
          window.open(apiurl.volunteerResources);
        }),
      },
      {
        label: 'Settings',
        Icon: SettingsTwoTone,
        selected: window.location.pathname === '/settings',
        onClick: clickHandler(() => {
          history.push('/settings');
        }),
      },
      {
        label: 'Sign out',
        Icon: LockOpenTwoTone,
        onClick: clickHandler(() => logOut()),
      },
    ];
  };

  const menuOptions = getMenuOptions();

  return (
    <>
      <IconButton
        size="large"
        edge="end"
        color="inherit"
        aria-label="menu"
        sx={{ mr: 2 }}
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MenuIcon />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        anchorEl={anchorEl.current}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: '20ch',
          },
        }}
      >
        {map(
          ({ Icon, label, onClick, selected }) => (
            <MenuItem key={label} onClick={onClick} selected={selected}>
              {Icon && (
                <ListItemIcon>
                  <Icon fontSize="small" />
                </ListItemIcon>
              )}
              <ListItemText>{label}</ListItemText>
            </MenuItem>
          ),
          menuOptions,
        )}
      </Menu>
    </>
  );
};

export { HeaderMenu };
